import BottomDialog from '../../../../../../components/bottomDialog';

const MenuBottomDialog = ({ dialogRef, closeBottomDialog, updateStatus }) => {
  return (
    <BottomDialog
      dialogRef={dialogRef}
      closeDialog={closeBottomDialog}
    >
      <div className='flex flex-col items-center gap-2'>
        <button
          className='border rounded-xl w-full py-2 bg-red-500 text-red-500 bg-opacity-20 border-red-500 border-opacity-40'
          onClick={updateStatus('INCOMPLETE')}
        >
          Give Up
        </button>
        <button
          className='border rounded-xl w-full py-2 mt-4'
          onClick={closeBottomDialog}
        >
          Cancel
        </button>
      </div>
    </BottomDialog>
  );
};

export default MenuBottomDialog;
